var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fanzone-form',{attrs:{"id":_vm.id,"redirectTo":"/#/fanzones-roadtours","label":"Trasy koncertowe","idStepsEvent":false,"idsRelatedEvents":true,"scenesEditor":false}})}
var staticRenderFns = []

export { render, staticRenderFns }